import React, { useEffect, useState } from 'react';
import './FineResponse.scss';

interface ShowEventDetail {
  issuerName: string;
  holdId: string;
  holdName?: string;
  amount: number;
}

const send = (payload: Record<string, unknown>): void => {
  if ((window as any).skyrimPlatform?.sendMessage) {
    (window as any).skyrimPlatform.sendMessage(JSON.stringify({ source: 'fine-response', ...payload }));
  }
};

// Target side of the fine flow - server-triggered (see justiceSystem.ts's
// asynchronous "showFineResponse"/"fineResponseAction"), unlike FinePrompt
// (the issuing guard's own, client-initiated amount-entry UI, which stays
// as-is). Payer picks "Payer" (charged via economySystem, capped by their
// actual balance server-side) or "Résister" (adds to their bounty for the
// hold instead - no other forced consequence).
const FineResponse: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [issuerName, setIssuerName] = useState('');
  const [holdName, setHoldName] = useState('');
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as ShowEventDetail;
      setIssuerName(detail.issuerName || 'Un garde');
      setHoldName(detail.holdName || detail.holdId || '');
      setAmount(Number(detail.amount) || 0);
      setVisible(true);
    };
    const hide = () => setVisible(false);
    window.addEventListener('skymp5-client:showFineResponse', handler);
    window.addEventListener('skymp5-client:hideFineResponse', hide);
    return () => {
      window.removeEventListener('skymp5-client:showFineResponse', handler);
      window.removeEventListener('skymp5-client:hideFineResponse', hide);
    };
  }, []);

  if (!visible) return null;

  const respond = (action: 'pay' | 'resist') => {
    setVisible(false);
    send({ action });
  };

  return (
    <div className="fine-response">
      <div className="fine-response__window skyrim-panel">
        <div className="fine-response__header">
          <span className="fine-response__title">Amende reçue</span>
        </div>

        <div className="fine-response__body">
          <p className="fine-response__text">
            <strong>{issuerName}</strong> t&apos;inflige une amende de <strong>{amount} Or</strong>
            {holdName ? <> pour {holdName}</> : null}.
          </p>
          <p className="fine-response__hint">Résister ajoutera ce montant à ta prime.</p>
        </div>

        <div className="fine-response__footer">
          <button type="button" className="fine-response__button fine-response__button--secondary" onClick={() => respond('resist')}>
            Résister
          </button>
          <button type="button" className="fine-response__button" onClick={() => respond('pay')}>
            Payer
          </button>
        </div>
      </div>
    </div>
  );
};

export default FineResponse;
